import React from "react"
import { HandleImages } from "../components/functions"
import Layout from "../components/layout"
import Resource from "../components/resource"
import ResourcesWrapper from "../components/resources-wrapper"
import "../css/covid.css"
import SEO from "../components/seo"
import { seodata } from "../components/seo-data"
 

var content = {
  hero: {
    title: " ",
    text: <div></div>,
  },
  resources:{
    resource1:{
      
      title:"Check Out Our Blog",
      text:" ",
      url:"/blog"
    },
    resource2:{
     
      title:"Watch On-Demand Webinars",
      text:" ",
      url:"/content-library"
    },
    resource3:{
      
      title: <span>We'd love to learn about your business or institution.<br/>  Schedule a consultation with us now.</span>,
      text:" ",
      url:"https://calendly.com/circadence-sales/discovery-call?month=2020-08"
    }, 
  },
}

class Covid extends React.Component {
 
  render() {
    return (
      <Layout><SEO title={seodata.covid.title} description={seodata.covid.description} keywords={seodata.covid.keywords} />
      
<div className="covid-wrapper">
        <div>
            <HandleImages name="doctorMask"/>
        </div>
        
        <div>
          <div>
            <h2>Our Commitment during COVID-19</h2>
            <p>
              The COVID pandemic and the stay-at-home requirements have created
              an unprecedented situation for learning institutions, small
              businesses, enterprises, government agencies, families and
              individuals. We are all effected on multiple levels.{" "}
            </p>

            <p>
              As with many that focus on cyber security, Circadence is attuned
              to the fact that cyber threats are peaking as digital
              vulnerabilities arise. Despite recent changes in how and where we
              work together, we remain committed to our mission to help protect
              our customers, partners, and their businesses through cyber
              education.{" "}
            </p>

            <p>
              We are supporting safe, remote work for our workforce as the
              Circadence team continues to serve our customers and partners
              through continued improvements to the Project Ares cyber learning
              platform. When the timing is right for your institution or
              organization, we are here to help upskill cyber professionals,
              enhance cyber education, and engage students learning remotely.{" "}
            </p>

            <p>
              We hope you are staying safe and secure during this time. Please
              contact us if Circadence can be of service to you.{" "}
            </p>
            <a href="/contact/" title="Contact Us">
            <button className="flat-button" name="contact" >Contact Us</button> 
            </a>
          </div>
        </div></div>

         
        <h3 style={{    margin:".5em 0px 0.5em 0.5em"}}>Keep Learning Cyber During the Pandemic  </h3>

        <ResourcesWrapper>
          <Resource
            image={<HandleImages name={"gamification"} />}
            title={content.resources.resource1.title}
            text={content.resources.resource1.text}
            url={content.resources.resource1.url}
          />
          <Resource
            image={<HandleImages name={"kidComputer"} />}
            title={content.resources.resource2.title}
            text={content.resources.resource2.text}
            url={content.resources.resource2.url}
          />
          <Resource
            image={<HandleImages name={"manWomanComputer"} />}
            title={content.resources.resource3.title}
            text={content.resources.resource3.text}
            url={content.resources.resource3.url}
          />
         
        </ResourcesWrapper>
      </Layout>
    )
  }
}

export default Covid
